var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bc6b6c15cece254cc842ecbaa6e2d304e9b7177d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gekofamcom@zacs-team"]={id:"bc6b6c15cece254cc842ecbaa6e2d304e9b7177d"};
      